import React, { useEffect, useRef, useState } from "react";

export default function VideoSeatingPlan({videoSrc}) {
    const dialogRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);

    const closeDialog = () => {
        dialogRef.current.close();
        setIsPlaying(false);
    };

    const getAutoplaySrc = () => {
        if (!videoSrc) return "";

        if (isPlaying) {
            const separator = videoSrc.includes("?") ? "&" : "?";
            return `${videoSrc}${separator}autoplay=1`;
        }

        return videoSrc;
    };

    return (
        <div className="seating-plan__video">
            <button type="button" className="btn seating-plan__video-btn" onClick={() => dialogRef.current.showModal()}>
                <span className="seating-plan__video-btn-inner">
                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H16C16.55 4 17.0208 4.19583 17.4125 4.5875C17.8042 4.97917 18 5.45 18 6V10.5L21.15 7.35C21.3167 7.18333 21.5 7.14167 21.7 7.225C21.9 7.30833 22 7.46667 22 7.7V16.3C22 16.5333 21.9 16.6917 21.7 16.775C21.5 16.8583 21.3167 16.8167 21.15 16.65L18 13.5V18C18 18.55 17.8042 19.0208 17.4125 19.4125C17.0208 19.8042 16.55 20 16 20H4Z" fill="#2B0539"/>
                    </svg>
                    <span>Watch a tour of the theatre</span>
                </span>
            </button>
            <dialog ref={dialogRef} className='seating-plan__video-dialog' onClose={() => setIsPlaying(false)}>
                <div className='dialog-container'>
                    <button type="button" className='btn--cross btn--dialog-close' onClick={closeDialog}>
                        <span className='sr-only'>Close dialog</span>
                        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="36" y="23" width="2" height="24" transform="rotate(90 36 23)"/>
                            <rect x="23" y="12" width="2" height="24" />
                        </svg>
                    </button>
                    <div className='dialog-content'>
                        <h1 className='booking-pathway__header'>Watch a video tour of the theatre</h1>

                        <div className="dialog-content__video">
                            {videoSrc && (
                                <iframe
                                    key={isPlaying ? "playing" : "preview"}
                                    src={getAutoplaySrc()}
                                    width="100%"
                                    height="100%"
                                    allow="autoplay; fullscreen; picture-in-picture"
                                    allowFullScreen
                                />
                            )}
                            {!isPlaying &&
                                <button type="button" className='btn--play' onClick={() => setIsPlaying(true)}>
                                    <span className='sr-only'>Play video</span>
                                    <svg width="104" height="104" viewBox="0 0 104 104" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M39.2337 73.8061L73.806 51.7937L39.2337 29.7814V73.8061ZM51.7937 103.587C44.7152 103.587 38.0252 102.228 31.7237 99.5087C25.4221 96.7895 19.919 93.0776 15.2144 88.373C10.5098 83.6684 6.79793 78.1654 4.07876 71.8638C1.35959 65.5622 0 58.8722 0 51.7937C0 44.6289 1.35959 37.8957 4.07876 31.5942C6.79793 25.2926 10.5098 19.8111 15.2144 15.1497C19.919 10.4882 25.4221 6.79793 31.7237 4.07876C38.0252 1.35959 44.7152 0 51.7937 0C58.9585 0 65.6917 1.35959 71.9933 4.07876C78.2948 6.79793 83.7763 10.4882 88.4378 15.1497C93.0992 19.8111 96.7895 25.2926 99.5087 31.5942C102.228 37.8957 103.587 44.6289 103.587 51.7937C103.587 58.8722 102.228 65.5622 99.5087 71.8638C96.7895 78.1654 93.0992 83.6684 88.4378 88.373C83.7763 93.0776 78.2948 96.7895 71.9933 99.5087C65.6917 102.228 58.9585 103.587 51.7937 103.587ZM51.7937 95.8184C64.0516 95.8184 74.4535 91.5238 82.9994 82.9347C91.5454 74.3456 95.8184 63.9652 95.8184 51.7937C95.8184 39.5359 91.5454 29.134 82.9994 20.588C74.4535 12.042 64.0516 7.76906 51.7937 7.76906C39.6222 7.76906 29.2419 12.042 20.6527 20.588C12.0636 29.134 7.76906 39.5359 7.76906 51.7937C7.76906 63.9652 12.0636 74.3456 20.6527 82.9347C29.2419 91.5238 39.6222 95.8184 51.7937 95.8184Z" fill="white"/></svg>
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </dialog>
        </div>
    )
}